module.exports = __webpack_public_path__ + "img/undraw_Dropdown_menu_re_jqqs 1.6cebfe2c.svg";